import { PropTypes } from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { SCButton, SCInput, SCModal, SCModalBody } from 'rollup-allspark';
import { isFunction, isNumber } from '../../../utils';
import { updateEntity } from '../actions';
import { makeSelectProperty } from '../selector';

const AdditionalFee = ({
  additionalFee = 0,
  isOpen = false,
  onClose = () => {},
  updateField = () => {},
}) => {
  const ref = useRef(null);
  const [additionalFeeAmount, setAdditionalFeeAmount] = useState(0);

  useEffect(() => {
    if (isOpen) {
      ref.current.showModal();
    } else {
      ref.current.closeModal();
    }
  }, [isOpen]);

  useEffect(() => {
    setAdditionalFeeAmount(additionalFee);
  }, [additionalFee]);

  const onModalClose = () => {
    if (isFunction(onClose)) {
      onClose();
    }
  };

  const onConfirm = () => {
    updateField({
      additionalFee: additionalFeeAmount,
    });

    onModalClose();
  };

  const body = (
    <SCModalBody>
      <div className="flex flex-col gap-y-4 normal-case">
        <div className="text-base font-medium text-black">Additional Fee</div>
        <SCInput
          type="number"
          inputClass="border rounded-lg scam-business-name"
          value={additionalFeeAmount}
          handleChange={e =>
            setAdditionalFeeAmount(parseFloat(e.target.value) || 0)
          }
          hasError={!isNumber(additionalFeeAmount)}
          hint={
            !isNumber(additionalFeeAmount)
              ? 'Please enter a valid Additional Fee'
              : ''
          }
        />
        <div className="pt-8 flex gap-x-4 justify-end">
          <SCButton variant="danger-outline" action={onModalClose}>
            Cancel
          </SCButton>
          <SCButton action={onConfirm}>Confirm</SCButton>
        </div>
      </div>
    </SCModalBody>
  );

  return (
    <SCModal
      ref={ref}
      variant="white"
      body={body}
      size="lg"
      onModalClose={onModalClose}
    />
  );
};

AdditionalFee.propTypes = {
  additionalFee: PropTypes.number,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  updateField: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  additionalFee: makeSelectProperty('additionalFee'),
});

const mapDispatchToProps = dispatch => ({
  updateField: val => dispatch(updateEntity(val)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(AdditionalFee);
